<template>
  <v-container fluid id="crm">
    <v-layout wrap>
      <v-flex xs12 sm4>
        <h3 class="title">{{$t('Employee')}}</h3>
      </v-flex>
      <v-flex xs12 sm8 class="text-xs-right">
        <template v-if="loading">
          <v-btn outline loading color="grey"></v-btn>
          <v-btn outline loading color="grey"></v-btn>
        </template>
        <template v-else>
          <template v-if="$store.getters.getPackage != 'premium'">
            <v-btn color="grey" outline>
              <i class="fas fa-file-import"></i>
              &nbsp;
              {{$t('Import')}}&nbsp;
              <v-premium-lock :inline="true"></v-premium-lock>
            </v-btn>

            <v-btn color="grey" outline>
              <i class="fas fa-file-export"></i>
              &nbsp;
              {{$t('export')}}&nbsp;
              <v-premium-lock :inline="true"></v-premium-lock>
            </v-btn>
          </template>
          <template v-else>
            <v-btn color="grey" :disabled="delayImport" outline @click="onClickUploadButton">
              <i class="fas fa-file-import"></i>
              &nbsp;
              {{$t('Import')}}
            </v-btn>
            <v-btn color="grey" outline @click="exportCustomer(0)">
              <i class="fas fa-file-export" />
              &nbsp;
              {{$t('export')}}
            </v-btn>
            <input
              type="file"
              class="form-control-file pt-2"
              name="csvUpload"
              :id="'csvUpload'"
              data-vv-as="File"
              v-validate="'mimes:text/csv'"
              accept=".csv"
              @change="onFileChange($event)"
              style="overflow: hidden;position: fixed;width: 1px;height: 1px;z-index: -1;opacity: 0;"
            />
          </template>
        </template>

        <v-btn dark depressed color="primary" @click="showAdvance = !showAdvance">
          <v-icon>search</v-icon>
          &nbsp;
          {{$t('advanced search')}}&nbsp;
          <i
            class="fas fa-angle-down"
            v-if="!showAdvance"
          ></i>
          <i class="fas fa-angle-up" v-else></i>
        </v-btn>
      </v-flex>
    </v-layout>
    <div
      v-if="showAdvance"
      class="mb-4"
      style="border: 1px solid #eee;border-radius: 10px;position: relative;"
    >
      <template>
        <v-premium-plan-popup
          :showAll="false"
          marginTop="65"
          v-if="$store.getters.getPackage != 'premium'"
          style="border-radius: 10px;"
        ></v-premium-plan-popup>
        <filter-customer v-model="filter" :hideMain="true">
          <v-btn outline color="grey" @click="clearSearch">{{$t('Clear Search')}}</v-btn>
          <v-btn depressed @click="onSearch" color="primary">
            <i class="fas fa-search mr-1"></i>
            {{$t('Search')}}
          </v-btn>

          <div slot="append" slot-scope="{filter}" v-if="selectedBot.theme == 'hafele'">
            <v-layout wrap>
              <v-flex xs12 sm4 class="form-control pa-1">
                <label for class="caption">{{$t('Emp ID')}}</label>
                <input
                  type="text"
                  :placeholder="$t('Emp ID')"
                  v-model="filter.emp_id"
                  class="form-control"
                  maxlength="255"
                />
              </v-flex>
              <v-flex xs12 sm4 class="form-control pa-1">
                <label for class="caption">{{$t('Emp First Name')}}</label>
                <input
                  type="text"
                  :placeholder="$t('Emp First Name')"
                  v-model="filter.emp_first_name"
                  class="form-control"
                  maxlength="255"
                />
              </v-flex>
              <v-flex xs12 sm4 class="form-control pa-1">
                <label for class="caption">{{$t('Emp Last Name')}}</label>
                <input
                  type="text"
                  :placeholder="$t('Emp Last Name')"
                  v-model="filter.emp_last_name"
                  class="form-control"
                  maxlength="255"
                />
              </v-flex>
              <v-flex xs12 sm4 class="form-control pa-1">
                <label for class="caption">{{$t('Division')}}</label>
                <input
                  type="text"
                  :placeholder="$t('Division')"
                  v-model="filter.division"
                  class="form-control"
                  maxlength="255"
                />
              </v-flex>
              <v-flex xs12 sm4 class="form-control pa-1">
                <label for class="caption">{{$t('Department')}}</label>
                <input
                  type="text"
                  :placeholder="$t('Department')"
                  v-model="filter.department"
                  class="form-control"
                  maxlength="255"
                />
              </v-flex>
            </v-layout>
          </div>
        </filter-customer>
      </template>
    </div>

    <div class="text-xs-right">
      <v-btn outline color="primary" @click="keyAddHafeleCustomer++;showAddEmployee = true">
        <v-icon>add</v-icon>
        {{$t('Add')}}
      </v-btn>
      <v-dialog v-model="showAddEmployee" max-width="600" persistent>
        <v-card>
          <v-card-text>
            <hafele-customer-manage
              v-model="addHafeleCustomer"
              type="add"
              :exceptid="excludedEmpID"
              @close="onClose"
              @onSaveEmpolyee="onSaveEmpolyee"
              :key="`add_${keyAddHafeleCustomer}`"
            ></hafele-customer-manage>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>

    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="users"
      class="elevation-1"
      v-bind:pagination.sync="pagination"
      hide-actions
    >
      <template v-slot:items="props">
        <hafele-customer-item
          v-model="props.item"
          @deleteEmployee="deleteEmployee"
          :excludedEmpID="excludedEmpID"
          :key="'employee_'+props.item.emp_id"
        ></hafele-customer-item>
      </template>

      <div class="text-xs-center" slot="no-data">{{$t('No customer')}}</div>
    </v-data-table>

    <!-- <div class="text-xs-center mt-4">
      <v-btn
        outline
        color="primary"
        :loading="loading"
        :disabled="!hasNext"
        @click="getMoreCustomers"
      >{{$t('Next')}}</v-btn>
    </div>-->
  </v-container>
</template>

<script>
import api from '@/api'
import config from '@/config'
import moment from 'moment'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import Multiselect from 'vue-multiselect'
import HafeleCustomerItem from './HafeleCustomerItem'
import { mapGetters } from 'vuex'
import FilterCustomer from '@/components/elements/FilterCustomer'
import HafeleCustomerManage from './HafeleCustomerManage'
import Papa from 'papaparse'

export default {
  data: function() {
    return {
      showAddEmployee: false,
      headers: [
        { text: '', sortable: false },
        { text: this.$t('ID'), value: 'emp_id' },
        { text: this.$t('name'), value: 'emp_first_name' },
        { text: this.$t('Division'), value: 'division' },
        { text: this.$t('Department'), value: 'department' },
        { text: this.$t('Position Name'), value: 'position_name' },
        { text: this.$t('Level'), value: 'position_level' },
        { text: this.$t('Status'), value: 'emp_status' },
        { text: this.$t('Leave Balance'), value: 'leave_balance' },
        { text: this.$t('Start Point'), value: 'start_point' },
        { text: this.$t('Additional Point'), value: 'additional_point' },
        { text: this.$t('Point Balance'), value: 'point_balance' },
        { text: this.$t('Redeem Balance'), value: 'redeem_point' },
        { text: this.$t('Redeem Detail'), sortable: false }
      ],
      pagination: { rowsPerPage: -1 },
      tag: '',
      singleStatus: '',
      showAdvance: false,
      users: [],
      limit: 10000,
      offset: 0,
      hasNext: true,
      count: 0,
      gendercount: '',
      users_count: [],
      intents: [],
      delayImport: false,
      search: '',
      filter: {
        fullname: '',
        gender: {
          label: this.$t('All'),
          value: 'all'
        },
        locale: null,
        app: {
          label: this.$t('All'),
          value: 'all'
        },
        intent: null,
        email: '',
        phoneno: '',
        messagesent: {
          value: null,
          symbol: {
            value: 'g__',
            label: this.$t('Greater than')
          }
        },
        timezone: {
          from: -12,
          to: 14
        },
        activeDate: {
          enable: false,
          start: null,
          end: null
        },
        registerDate: {
          enable: false,
          start: null,
          end: null
        },
        status: '',
        tags: ''
      },
      loading: true,
      errorFilterTag: [],
      errorFilterStatus: [],
      customerfromfb: null,
      addHafeleCustomer: null,
      keyAddHafeleCustomer: 0
    }
  },
  components: {
    ScaleLoader,
    HafeleCustomerItem,
    PulseLoader,
    Multiselect,
    FilterCustomer,
    HafeleCustomerManage
  },
  mounted: async function() {
    var vm = this
    vm.getIntent(function() {
      vm.loading = true
      vm.getLoadUsers(vm.limit, vm.offset).then(
        function(users) {
          vm.offset += vm.limit
          vm.users = vm.users.concat(users)
          vm.loading = false
        },
        function() {
          vm.loading = false
        }
      )
    })
    vm.$store.dispatch('loadStatus')
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    pageid: function() {
      return this.$store.state.selectedBot.pageid
    },
    filterIntent: function() {
      var vm = this
      vm.intents.sort(function(a, b) {
        var nameA = a.intentname.toUpperCase() // ignore upper and lowercase
        var nameB = b.intentname.toUpperCase() // ignore upper and lowercase
        if (a.intentname[0] == '{' && a.intentname[a.intentname.length - 1] == '}') {
          return 1
        }
        if (b.intentname[0] == '{' && b.intentname[b.intentname.length - 1] == '}') {
          return -1
        }
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }

        // names must be equal
        return 0
      })
      var intents = []
      $.each(vm.intents, function(index, intent) {
        intents.push(intent.intentname)
      })
      return intents
    },
    tags: {
      get() {
        let vm = this
        if (vm.filter && vm.filter.tags && vm.filter.tags !== '') {
          var tags = []
          tags = vm.filter.tags.split(',')
          var result = []
          if (tags) {
            tags.map(function(tag, index) {
              result.push({ text: tag })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function(tag, index) {
            result.push(tag.text)
          })
        }
        vm.filter.tags = result.join(',')
      }
    },
    status: {
      get() {
        let vm = this
        if (vm.filter && vm.filter.status && vm.filter.status !== '') {
          var status = []
          status = vm.filter.status.split(',')
          var result = []
          if (status) {
            status.map(function(s, index) {
              result.push({ text: s })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function(s, index) {
            result.push(s.text)
          })
        }
        vm.filter.status = result.join(',')
      }
    },
    excludedEmpID: function() {
      var result = []
      var vm = this
      $.each(vm.users, function(index, user) {
        result.push(user.emp_id)
      })
      return result.join(',')
    }
  },
  methods: {
    resetEmployee() {
      var vm = this
      vm.loading = true
      vm.offset = 0
      vm.getLoadUsers(vm.limit, vm.offset).then(
        function(users) {
          vm.users = []
          vm.offset += vm.limit
          vm.users = vm.users.concat(users)
          vm.loading = false
        },
        function() {
          vm.loading = false
        }
      )
    },
    onClickUploadButton: function() {
      document.getElementById('csvUpload').click()
    },
    onFileChange(event) {
      let vm = this
      vm.loading = true
      let files = event.target.files || event.dataTransfer.files
      if (!files.length) return
      if (files[0].type == 'text/csv' || files[0].type == 'application/vnd.ms-excel') {
        var myFile = files[0]
        // var reader = new FileReader()

        Papa.parse(myFile, {
          skipEmptyLines: true,
          complete: function(results) {
            var isFound = true
            if (results.data.length > 0 && results.data[0].length == 14) {
              results.data[0].map(col => {
                var found = [
                  'emp_id',
                  'password',
                  'emp_first_name',
                  'emp_last_name',
                  'division',
                  'department',
                  'position_name',
                  'position_level',
                  'emp_status',
                  'leave_balance',
                  'start_point',
                  'additional_point',
                  'point_balance',
                  'redeem_point'
                ].includes(col.toLowerCase())
                if (!found) {
                  isFound = false
                  return false
                }
              })
            } else {
              isFound = false
            }
            if (!isFound) {
              vm.$swal.fire({
                title: vm.$t('Can not parse this csv'),
                type: 'error',
                confirmButtonText: vm.$t('Confirm'),
                cancelButtonText: vm.$t('cancel'),
                reverseButtons: true
              })
              vm.loading = false
              return false
            }

            var employees = []
            console.log(results.data)

            if (results.data.length > 1) {
              var count = 0
              results.data.map(function(el, index) {
                if (index > 0) {
                  var emp_id = el[0]
                  if (emp_id.match(/^[=\"].*[\"]/g)) {
                    emp_id = emp_id.split('="')[1]
                    emp_id = emp_id.split('"')[0]
                  }
                  if (emp_id.length == 5) {
                    employees.push({
                      emp_id: emp_id,
                      password: el[1],
                      emp_first_name: el[2],
                      emp_last_name: el[3],
                      division: el[4],
                      department: el[5],
                      position_name: el[6],
                      position_level: el[7],
                      emp_status: el[8],
                      leave_balance: el[9],
                      start_point: el[10],
                      additional_point: el[11],
                      point_balance: el[12],
                      redeem_point: el[13]
                    })
                    count++
                  }
                }
              })
              if (employees.length == 0) {
                vm.$swal.fire({
                  title: vm.$t('Import unsuccessful'),
                  type: 'error',
                  confirmButtonText: vm.$t('Confirm'),
                  reverseButtons: true
                })
                vm.loading = false
                return
              } else {
                var data = {
                  emp: employees
                }
                api.uploadHafeleUsername(data, function(error, response) {
                  if (error) {
                    console.error(error)
                    vm.$swal.fire({
                      title: vm.$t('Something went wrong'),
                      type: 'error',
                      confirmButtonText: vm.$t('Confirm'),
                      cancelButtonText: vm.$t('cancel'),
                      reverseButtons: true
                    })
                    vm.loading = false
                    return
                  }
                  vm.$swal
                    .fire({
                      title: vm.$t('Employee imported'),
                      text: `ทำการนำเข้าสำเร็จทั้งหมด ${count} ครั้ง`,
                      type: 'success',
                      confirmButtonText: vm.$t('Confirm'),
                      cancelButtonText: vm.$t('cancel'),
                      reverseButtons: true
                    })
                    .then(result => {
                      vm.resetEmployee()
                    })
                })
              }
            } else {
              vm.$swal.fire({
                title: vm.$t('No employee to import'),
                type: 'error',
                confirmButtonText: vm.$t('Confirm'),
                cancelButtonText: vm.$t('cancel'),
                reverseButtons: true
              })
            }
          }
        })
      } else {
      }
      event.target.value = ''
    },
    deleteEmployee(payload) {
      var vm = this
      var emp_index = vm.users.findIndex(function(el) {
        return payload == el.emp_id
      })
      if (emp_index != -1) {
        vm.$store.dispatch('loading')
        var data = {
          pageid: vm.selectedBot.pageid,
          emp_id: payload
        }
        api.deleteHafeleUsername(data, function(error, response) {
          if (error) {
            console.error(error)
            vm.$store.dispatch('loading')
            return
          }
          vm.users.splice(emp_index, 1)
          vm.$store.dispatch('loading')
        })
      }
    },
    onClose() {
      this.showAddEmployee = false
    },
    onSaveEmpolyee(payload) {
      this.users.push(payload)
      this.showAddEmployee = false
    },
    checkTag(obj) {
      this.errorFilterTag = []
      if (obj.tag.text.length > 20) {
        this.errorFilterTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addTags: function(newTags) {
      this.tags = newTags
    },
    checkStatus(obj) {
      this.errorFilterStatus = []
      if (obj.tag.text.length > 20) {
        this.errorFilterStatus.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterStatus.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addStatus: function(newTags) {
      this.status = newTags
    },
    clearSearch: function() {
      this.filter = {
        fullname: '',
        gender: {
          label: this.$t('All'),
          value: 'all'
        },
        locale: null,
        app: {
          label: this.$t('All'),
          value: 'all'
        },
        intent: null,
        messagesent: {
          value: null,
          symbol: {
            value: 'g__',
            label: this.$t('Greater than')
          }
        },
        timezone: {
          from: -12,
          to: 14
        },
        activeDate: {
          enable: false,
          start: null,
          end: null
        },
        registerDate: {
          enable: false,
          start: null,
          end: null
        },
        tags: '',
        status: ''
      }
      this.$forceUpdate()

      this.onSearch()
    },
    onSearch: function() {
      var vm = this
      vm.$validator.validate().then(result => {
        if (!result) {
          vm.goToErrorInput()
          return false
        }
        vm.offset = 0
        vm.hasNext = true
        vm.users = []
        vm.loading = true
        vm.getLoadUsers(vm.limit, vm.offset).then(
          function(users) {
            vm.users = vm.users.concat(users)
            vm.loading = false
          },
          function(error) {
            vm.loading = false
          }
        )
      })
    },
    getLoadUsers: function(limit, offset) {
      let vm = this
      return new Promise((resolve, reject) => {
        let data = {
          pageid: vm.pageid,
          grouptype: vm.grouptype,
          filter: vm.filter
        }
        // console.log(limit, offset)

        api.getHafeleUsername(data, function(error, response) {
          if (error) {
            reject(error)
          }
          if (vm.limit > response.data.length) {
            vm.hasNext = false
          }

          var users = response.data
          resolve(users)
        })
      })
    },
    getMoreCustomers: function() {
      var vm = this
      vm.loading = true
      vm.getLoadUsers(vm.limit, vm.offset).then(
        function(users) {
          vm.offset += vm.limit
          vm.users = vm.users.concat(users)
          vm.loading = false
        },
        function(error) {
          vm.loading = false
        }
      )
    },
    onFailLoad: function(index) {
      this.$set(this.users[index], 'profile_pic', '/static/img/assets/livechat/profile.png')
    },
    getFormatDate: function(date, format) {
      return moment(date).format(format)
    },
    onActiveStartDate: function(value) {
      var vm = this
      if (moment(this.filter.activeDate.end).isBefore(value)) {
        this.filter.activeDate.end = value
      }
      this.filter.activeDate.start = value
    },
    onActiveEndDate: function(value) {
      var vm = this
      if (moment(value).isBefore(this.filter.activeDate.start)) {
        this.filter.activeDate.start = value
      }
      this.filter.activeDate.end = value
    },
    onRegisterStartDate: function(value) {
      var vm = this
      if (moment(this.filter.registerDate.end).isBefore(value)) {
        this.filter.registerDate.end = value
      }
      this.filter.registerDate.start = value
    },
    onRegisterEndDate: function(value) {
      var vm = this
      if (moment(value).isBefore(this.filter.registerDate.start)) {
        this.filter.registerDate.start = value
      }
      this.filter.registerDate.end = value
    },
    getIntent: function(callback) {
      let vm = this
      let auth = null
      let data = {
        pageid: vm.pageid
      }
      api.getIntent(data, function(error, response) {
        if (error) {
          console.error(error)
          return
        }
        if (response.data) {
          var isFoundDefault = false
          $.each(response.data, function(index, val) {
            var intent = val
            intent.isShow = false
            vm.intents.push(intent)
          })
        }
        callback()
      })
    },
    exportCustomer: function(offset = 0) {
      let vm = this
      let csvContent = ''

      var limit = 50000
      vm.loading = true

      vm.getLoadUsers(limit, offset).then(
        function(users) {
          if (users && users.length > 0) {
            csvContent +=
              'emp_id,password,emp_first_name,emp_last_name,division,department,position_name,position_level,emp_status,leave_balance,start_point,additional_point,point_balance,redeem_point'

            csvContent += '\r\n'

            $.each(users, function(index, val) {
              let row = ''

              row += `="${val.emp_id.replace(/\r?\n|\r/g, ' / ')}",`
              row += '"",'
              row += `"${val.emp_first_name.replace(/\r?\n|\r/g, ' / ')}",`
              row += `"${val.emp_last_name.replace(/\r?\n|\r/g, ' / ')}",`
              row += `"${val.division.replace(/\r?\n|\r/g, ' / ')}",`
              row += `"${val.department.replace(/\r?\n|\r/g, ' / ')}",`
              row += `"${val.position_name.replace(/\r?\n|\r/g, ' / ')}",`
              row += `"${val.position_level.replace(/\r?\n|\r/g, ' / ')}",`
              row += `"${val.emp_status.replace(/\r?\n|\r/g, ' / ')}",`
              row += `"${val.leave_balance}",`
              row += `"${val.start_point}",`
              row += `"${val.additional_point}",`
              row += `"${val.point_balance}",`
              row += `"${val.redeem_point}"`

              csvContent += row + '\r\n'
            })

            vm.exportCsv(csvContent, 'employee_' + offset)

            offset += limit
            if (users.length >= limit) {
              vm.exportCustomer(offset)
            } else {
              vm.loading = false
            }
          } else {
            vm.loading = false
          }
        },
        function() {
          vm.loading = false
        }
      )
    },
    importCustomer: function() {
      var vm = this

      // vm.$swal
      //   .fire({
      //     title: vm.$t('Do you want to import customer?'),
      //     type: 'question',
      //     showCancelButton: true,
      //     confirmButtonText: vm.$t('Confirm'),
      //     cancelButtonText: vm.$t('cancel'),
      //     reverseButtons: true
      //   })
      //   .then(result => {
      //     if (result.value) {
      //       var data = {
      //         pageid: vm.selectedBot.pageid
      //       }
      //       vm.loading = true
      //       vm.offset = 0
      //       vm.hasNext = true
      //       vm.users = []
      //       api.insertUsersFromInbox(data, function(error, response) {
      //         if (error) {
      //           vm.loading = false
      //           return
      //         }
      //         vm.getLoadUsers(vm.limit, vm.offset).then(
      //           function(users) {
      //             vm.users = vm.users.concat(users)

      //             vm.delayImport = true
      //             vm.$swal.fire({
      //               title: vm.$t('Import customer successful'),
      //               type: 'success',
      //               confirmButtonText: vm.$t('Confirm'),
      //               cancelButtonText: vm.$t('cancel'),
      //               reverseButtons: true
      //             })
      //             vm.loading = false
      //           },
      //           function(error) {
      //             vm.loading = false
      //           }
      //         )
      //       })
      //     }
      //   })
    }
  },
  watch: {
    count: function(newVal, oldVal) {
      let vm = this
      if (newVal != oldVal) {
        vm.$emit('onUserLoaded', vm.count)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/dashboard/HafeleCustomers.vue